export const hello = (() => {
  // console.log('Hello Gradi Theme Base')
})()